export const CORS_BYPASS = "https://cors-anywhere.herokuapp.com/";
// dev
//export const BASE_API_URL = "https://pgpaypub.azurewebsites.net/";
// live
 export const BASE_API_URL = "https://api-paypup.azurewebsites.net/";

//adminlogin
export const LOGIN_URL = BASE_API_URL + "login/login";
export const CREATE_ADMIN_USER = BASE_API_URL + "user/createAdminUser";
export const EMPLOYEE_LIST = BASE_API_URL + "user/listUser";
export const DELETE_USER = BASE_API_URL + "user/deleteUser";
export const GET_SINGLE_USER = BASE_API_URL + "user/User";
export const UPDATE_ADMIN_USER = BASE_API_URL + "user/updateAdminUser";
export const UPLOAD_FILE = BASE_API_URL + "uploadFile/uploadFile";
export const CHANGE_PASSWORD = BASE_API_URL + "common/changePassword";
export const UPDATE_AGENCY_USER = BASE_API_URL + "user/updateAgencyUser";

//Agency
export const AGENCY_LIST = BASE_API_URL + "agency/listAgency";
export const GET_LICENSE_TEMPLATE =
  BASE_API_URL + "agency/getAgencyTemplateDetails";
export const AGENCY_POST = BASE_API_URL + "agency/createAgency";
export const CREATE_AGENCY_USER = BASE_API_URL + "user/createAgencyUser";
export const AGENCY_LICENSE_LIST = BASE_API_URL + "license/getLicenseDetails";
export const AGENCY_DETAILS_URL = BASE_API_URL + "/agency/agency";
export const AGENCY_UPDATE_URL = BASE_API_URL + "agency/updateAgency";
export const CREATE_LICENSE_TEMPLATE =
  BASE_API_URL + "license/createLicenseTemplate";
export const LICENSE_CATEGORY = BASE_API_URL + "license/licenceCategory";
export const GET_SINGLE_LICENSE = BASE_API_URL + "license/license";
export const GET_CATEGORY_DETAILS = BASE_API_URL + "license/getCategoryDetails";
export const DELETE_CATEGORY_DETAILS =
  BASE_API_URL + "license/deleteCategoryDetails";
export const GET_KERNEL_LICENSE = BASE_API_URL + "license/getLicenseDetails";

//Common
export const AGENCY_URL = BASE_API_URL + "agency/checkAgencyURLExist";
export const STATE_LIST = BASE_API_URL + "common/getState";

//Dashboard
export const ADMIN_DASHBOARD = BASE_API_URL + "dashBoard/adminDashboard";
export const AGENCY_DASHBOARD = BASE_API_URL + "dashBoard/agencyDashboard";
export const AGENCY_REPORT = BASE_API_URL + "dashBoard/agencyMonthlyReport";
export const ADMIN_DASHBOARD_REPORT =
  BASE_API_URL + "dashBoard/adminMonthlyReport";

//License
export const UPDATE_LICENSE = BASE_API_URL + "license/updateLicenseStatus";
export const END_USER_LOGIN_URL = BASE_API_URL + "login/endUserLogin";
export const END_USER_LICENCE_CATEGORY_DETAILS_URL =
  BASE_API_URL + "/license​/getCategoryDetails";
//Plan
export const CREATE_LICENSE_PLAN =
  BASE_API_URL + "licensePlan/createLicensePlan";
export const GET_LICENSE_PLAN = BASE_API_URL + "licensePlan/selectPlan";
export const DELETE_LICENSE_PLAN =
  BASE_API_URL + "licensePlan/deleteLicensePlan";
export const GET_SINGLE_LICENSE_PLAN = BASE_API_URL + "licensePlan/licensePlan";
export const UPDATE_LICENSE_PLAN =
  BASE_API_URL + "licensePlan/updateLicensePlan";
//forget Password
export const FORGET_PASSWORD_OTP_URL =
  BASE_API_URL + "common/sendForgetPasswordOTP";
export const FORGET_PASSWORD_OTP_END_USER =
  BASE_API_URL + "common/sendForgetPasswordOTPForEndUser";
export const FORGET_PASSWORD_URL = BASE_API_URL + "common/forgetPassword";
export const FIRST_TIME_PASSWORD_URL =
  BASE_API_URL + "common/firstTimeUpdatePassword";

export const AGENCY_IDLOGO_URL = BASE_API_URL + "agency/getAgencyIdAndLogo";

//end user create
export const USER_CREATE_URL = BASE_API_URL + "endUser/createEndUser";
//end user update
export const UPDATE_END_USER = BASE_API_URL + "endUser/updateEndUser";
//dog
export const DOG_CREATE_URL = BASE_API_URL + "dog/dogDetails";
export const DOG_LISTING_URL = BASE_API_URL + "dog/getDogDetailsByUserId";
export const DOG_DELETE_URL = BASE_API_URL + "dog/deleteDogDetails";
export const SINGLE_DOG_DETAILS_URL = BASE_API_URL + "dog/getDogDetails";
export const UPDATE_DOG_DETAILS_URL = BASE_API_URL + "dog/updateDogDetails";
export const UPDATE_LICENSE_STATUS = BASE_API_URL + "dog/updateLicenseStatus";
export const DOG_CATEGORY_ANSWER = BASE_API_URL + "dog/categoryAnswer";
export const DOG_REQUIRED_DOCUMENT_ANSWERS =
  BASE_API_URL + "dog/licenseRequiredDocDetails";
export const GET_DOG_LICENCE_ID = BASE_API_URL + "dog/dogLicenseDetails";

//Transaction -customer
export const CUSTOMER_TRANSACTION_URL =
  BASE_API_URL + "payment/getPaymentDetails";

//licence-customer
export const CUSTOMER_LICENCE_LISTING_URL =
  BASE_API_URL + "license/getLicenseDetails";
//requireddocument
export const REQUIRED_DOCUMENT = BASE_API_URL + "license/licenseRequiredDoc";
//report
export const ADMIN_AGENCY_REPORT = BASE_API_URL + "report/getAdminAgencyReport";
export const ADMIN_PAYMENT_REPORT =
  BASE_API_URL + "report/getAdminPaymentReport";
export const AGENCY_LICENSE_REPORT =
  BASE_API_URL + "report/getAgencyLicenseReport";
export const AGENCY_CUSTOMER_REPORT =
  BASE_API_URL + "report/getAgencyCustomerReport";
export const AGENCY_CUSTOMER_PAYMENT_REPORT =
  BASE_API_URL + "report/getAgencyCustomerPaymentReport";
//userlicenseplan
export const USER_LICENSEPLAN =
  BASE_API_URL + "licensePlan/getAgencyLicensePlans";
export const USER_CHOOSE_PLAN = BASE_API_URL + "licensePlan/licensePlan";
//requiredDocument
export const ENDUSER_LICENSE_DETAILS =
  BASE_API_URL + "/license/endUserLicenseDetails";
export const GET_LICENSE_REQ_DOC =
  BASE_API_URL + "license/getLicenseRequiredDocDetails";
export const DELETE_REQ_DOC =
  BASE_API_URL + "license/deleteLicenseReqiuredDocDetails";
export const UPDATE_REQDOC = BASE_API_URL + "license/updateLicenseRequiredDoc";

export const ACTIVE_CHANGE =
  BASE_API_URL + "license/updateActiveAndDeactiveTemplate";

export const GET_USER = BASE_API_URL + "user/User";
export const GET_PAYMENT = BASE_API_URL + "payment/getPaymentDetails";
export const CREATE_GUEST_USER = BASE_API_URL + "endUser/createGuestUser";
export const UPDATE_CREATE_GUEST_USER =
  BASE_API_URL + "endUser/updateGuestUser";
export const AGENCY_FEE = BASE_API_URL + "payment/getAgencyFee";

//Social Login Url
export const SOCIAL_LOGIN_URL = BASE_API_URL + "login/endUserLoginProvider";
export const UPLOAD_PDF_FILE = BASE_API_URL + "uploadFile/uploadPDFSplitFile";
export const PAYMENT_PROCESS =
  BASE_API_URL + "payment/paymentProcessingService";
export const DOG_LICENSE_DETAILS = BASE_API_URL + "dog/getDogLicenseDetails";

export const REFUND_PAYMENT = BASE_API_URL + "payment/refundPayment";
export const FORGET_PASSWORD_ENDUSER =
  BASE_API_URL + "common/sendForgetPasswordOTPForEndUser";

export const DELETE_AGENCY = BASE_API_URL + "agency/deleteAgency";
export const DECRYPT_PASSWORD_URL = BASE_API_URL + "common/decryption";
export const LOOKUP_BY_NUMBER_URL = BASE_API_URL + "user/getCustomerLookup";
export const SAVE_LOOKUP_DETAILS = BASE_API_URL + "user/saveCustomerLookup";
export const UPDATE_LOOKUP_DETAILS = BASE_API_URL + "user/updateCustomerLookup";
export const LICENSE_URL = BASE_API_URL + "dog/updateDogLicenseUrl";

export const LOOKUP_BY_EMAIL_FOR_AGENCY =
  BASE_API_URL + "agency/agencyAdminLookup";
export const ALL_AGENCY_LIST = BASE_API_URL + "/agency/searchOrganization";
export const ADD_TEMPLATE_INSTRUCTIONS = BASE_API_URL + "license/updateTemplateInstruction";
